import React, { useState, useEffect } from 'react'
import './chat.css'
import EasySpeech from 'easy-speech'
import { isAndroid, isIOS } from "react-device-detect";
import Cookies from 'js-cookie';
import { ImCross } from 'react-icons/im'
import { GiCancel } from 'react-icons/gi'

import countVisitors from '../../hooks/countVisitors';
import getChat from '../../hooks/getChat'
import sendEmailAPI from '../../hooks/sendEmailAPI'
import geniewait from '../../assets/geniewait.mp4'
import genietalk from '../../assets/genietalk.mp4'
 
const Chat = ({ chatState, setBackEvents, emailDetails, setEmailDetails, ads }) => {
    const[chatLoading, setChatLoading] = useState(false)
    const[videoState, setVideoState] = useState(false)
    const[displayAds, setDisplayAds] = useState(false)
    const[displayAds2, setDisplayAds2] = useState(false)
    const[question, setQuestion] = useState('')
    const[answer, setAnswer] = useState('')
    const[emailSent, setEmailSent] = useState(false)

    useEffect(() => {
        // const genieCall = document.getElementById('genieCall')
        // const chatCall = document.getElementById('chatCall')

        // try {
        //     genieCall.appendChild(chatCall)
        // } catch (error) {
        //     console.log(error);            
        // }
    }, [])

    useEffect(() => {
        let timeoutID;

        if (chatState.animation === true) {
            timeoutID = setTimeout(() => {
                setDisplayAds(true)
            }, 2000);
        }

        return () => clearInterval(timeoutID)
    }, [chatState])

    useEffect(() => {
        EasySpeech.init();
        EasySpeech.detect()
        
        if (answer !== '') {
            if (document.getElementById("genieAnswer")) {
                document.getElementById("genieAnswer").innerHTML = '';
            }
            setVideoState(true)

            let splits = answer.split(' ')
            let tempSplits = []
            let tempArray = []
            let tempCount = 0

            for (let i = 0; i < splits.length; i++) {
                if (tempCount >= 20) {
                tempSplits.push(splits[i])
                tempArray.push(tempSplits.join(' '))
                tempSplits = []
                tempCount = 0
                } else {
                tempSplits.push(splits[i])
                tempCount = tempCount + 1
                }
                if (i === splits.length - 1) {
                tempArray.push(tempSplits.join(' '))
                tempSplits = []
                tempCount = 0
                }
            }

            for (let i = 0; i < tempArray.length; i++) {
                if (isIOS) {
                    EasySpeech.speak({
                      text: tempArray[i],
                      voice: EasySpeech.voices()[EasySpeech.voices().findIndex((e) => {return e.lang === 'es-ES'})],
                      boundary: event => console.debug('word boundary reached', event.charIndex),
                      error: e => console.log(e),
                    })
                } else if (isAndroid) {
                    EasySpeech.speak({
                        text: tempArray[i],
                        voice: EasySpeech.voices()[EasySpeech.voices().findIndex((e) => {return e.lang == 'es_ES'})],
                        boundary: event => console.debug('word boundary reached', event.charIndex),
                        error: e => console.log(e),
                    })
                } else {
                    EasySpeech.speak({
                        text: tempArray[i],
                        voice: EasySpeech.voices()[EasySpeech.voices().findIndex((e) => {return e.lang == 'es-ES'})],
                        boundary: event => console.debug('word boundary reached', event.charIndex),
                        error: e => console.log(e),
                    })
                }
            }
        }
    }, [answer])

    useEffect(() => {        
        let counter = 0;
        function animateResult() {
            if (document.getElementById("genieAnswer")) {
                document.getElementById("genieAnswer").innerHTML += answer.charAt(counter);
                counter++;
            }

            if (counter === answer.length) {
                setVideoState(false)
                setBackEvents(true)
            }
        }
        
        let timerID = setInterval(animateResult.bind(animateResult), 70);

        return () => {
            clearInterval(timerID)
            setVideoState(false)
            setBackEvents(true)
        }
    }, [answer]); 

    const handleChatButton = () => {
        if (question === '') {
            window.alert('Por favor ingrese una pregunta primero.')
        } else {
            EasySpeech.cancel()
            getChat({ setChatLoading: setChatLoading, setAnswer: setAnswer, setBackEvents: setBackEvents, question: question })
        }
        // if (Cookies.get('horoscopeEmail') || emailSent) {
        // } else {
        //     setEmailDetails(e => {return {...e, display: true}})
            
        //     const timeoutID = setTimeout(() => {
        //         setEmailDetails(e => {return {...e, animation: true}})
        //     }, 200);

        //     return () => clearTimeout(timeoutID)
        // }
    }

    // const handleEmail = () => {
    //     const regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
        
    //     if (emailDetails.email === '') {
    //         window.alert('Por favor complete el campo de correo electrónico.')
    //     } else if (!regex.test(emailDetails.email)) {
    //         window.alert('Por favor ingrese su correo electrónico correctamente.')
    //     } else {
    //         sendEmailAPI({ emailDetails: emailDetails, setEmailDetails: setEmailDetails, setEmailSent: setEmailSent })
    //         window.TiktokChat();
    //     }
    // }
    
    return (
        <>
            <div className="chat" style={{ display: (chatState.display) ? 'flex' : 'none', opacity: (chatState.animation) ? 1 : 0, pointerEvents: (chatState.events) ? 'all' : 'none' }}>
                {/* <div id='genieCall'></div> */}
                
                <p>Preguntale Al Genio Lo Que Quieras Saber</p>
                <div>
                    <div className="chatQuestion">
                        <p>Escribe To Pregunta Aqui:</p>
                        <div>
                            <input placeholder='Pregunta ...' value={question} onChange={(e) => setQuestion(e.currentTarget.value)} />
                            <button onClick={() => handleChatButton()} style={{ pointerEvents: (chatLoading) ? 'none' : 'all', opacity: (chatLoading) ? 0.5 : 1 }}>
                                {(chatLoading) ? (
                                    <div className="loader">
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                    </div>
                                ) : 'PREGUNTAR'}
                            </button>
                        </div>
                    </div>

                    <div className='chatFace'>
                        <div style={{ opacity: (videoState) ? 0 : 1 }} dangerouslySetInnerHTML={{ __html: `
                            <video
                            loop
                            muted
                            autoplay
                            playsinline
                            src="${geniewait}"
                            class="chatGenieVideo"
                            />
                        ` }}></div>
                        <div style={{ opacity: (videoState) ? 1 : 0 }} dangerouslySetInnerHTML={{ __html: `
                            <video
                            loop
                            muted
                            autoplay
                            playsinline
                            src="${genietalk}"
                            class="chatGenieVideo"
                            />
                        ` }}></div>
                    </div>

                    <div className="chatAnswer">
                        <div className='chatAnswerTitle'>Esto Es Lo Que El Genio Tiene Para Decirte:</div>
                        <div className='chatAnswerContent'>
                            <div className='chatFace2'>
                                <div style={{ opacity: (videoState) ? 0 : 1 }} dangerouslySetInnerHTML={{ __html: `
                                    <video
                                    loop
                                    muted
                                    autoplay
                                    playsinline
                                    src="${geniewait}"
                                    class="chatGenieVideo"
                                    />
                                ` }}></div>
                                <div style={{ opacity: (videoState) ? 1 : 0 }} dangerouslySetInnerHTML={{ __html: `
                                    <video
                                    loop
                                    muted
                                    autoplay
                                    playsinline
                                    src="${genietalk}"
                                    class="chatGenieVideo"
                                    />
                                ` }}></div>
                            </div>
                            <p id='genieAnswer'>La respuesta del Genio se mostrará aquí</p>
                        </div>
                    </div>
                </div>
            </div>
            
            {/* <div className="email-container" style={{ display: (emailDetails.display) ? 'flex' : 'none', opacity: (emailDetails.animation) ? 1 : 0 }}>
                <div className="email-box">
                    <ImCross className='email-box-cancel' size={24} color={'#000000'} onClick={() => {
                        setEmailDetails(e => {return {...e, animation: false}})
                        const timeoutID = setTimeout(() => {
                            setEmailDetails(e => {return {...e, display: false}})
                        }, 500);
                        return () => clearTimeout(timeoutID)
                    }}/>

                    <p>¡Descubre los secretos de tu futuro! Déjanos tu correo electrónico para comenzar a hacerle preguntas a nuestro genio.</p>
                    <input type="email" placeholder='abc123@email.com' value={emailDetails.email} onChange={(e) => {
                        setEmailDetails((prev) => {return {...prev, email: e.target.value}})   
                    }}/>
                    <button onClick={() => handleEmail()} style={{ opacity: (emailDetails.loading) ? 0.5 : 1 }}>
                        {(emailDetails.loading) ? (
                            <div className="loader">
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                        ) : 'SEND'}
                    </button>
                </div>
            </div> */}

            <div className="ads-container" style={{ opacity: (displayAds && chatState.animation) ? 1 : 0, pointerEvents: (displayAds && chatState.animation) ? 'all' : 'none' }}>
                {/* <a href={ads.url} target="_blank" onClick={() => console.log('click')}> */}
                <a href={ads.url} target="_blank" onClick={() => countVisitors({ page: 'spanish2-ads' })}>
                    <GiCancel size={24} color={'#444444'} style={{ display: (displayAds2) ? 'none' : 'block', background: 'rgba(255, 255, 255, 0.5)', borderRadius: '50%', position: 'absolute', top: '5px', right: '5px', zIndex: 5 }} onClick={() => {setDisplayAds2(true); window.open(ads.url);}}/>
                    <GiCancel size={24} color={'#444444'} style={{ display: (displayAds2) ? 'block' : 'none', background: 'rgba(255, 255, 255, 0.5)', borderRadius: '50%', position: 'absolute', top: '5px', right: '5px', zIndex: 5 }} onClick={() => {setDisplayAds(false);}}/>
                    <img src={ads.image} alt="ads-image" />
                </a>
            </div>
        </>
    )
}

export default Chat